import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
};

export type BrandCalculationDto = {
  __typename?: 'BrandCalculationDto';
  brandCode: Scalars['String'];
  includedCoverages: Array<IncludedCoverageDto>;
  price: PriceDto;
  product: CalculationProductDto;
};

export type CalculationBrandDto = {
  __typename?: 'CalculationBrandDto';
  _id: Scalars['String'];
  code: Scalars['String'];
  name: Scalars['String'];
  shortName: Scalars['String'];
};

export type CalculationDto = {
  __typename?: 'CalculationDto';
  additionalCoverages: Array<Coverage>;
  calculations: Array<BrandCalculationDto>;
};

export type CalculationInput = {
  contractor?: InputMaybe<Scalars['String']>;
  includedCoverages?: InputMaybe<Array<IncludedCoverageInput>>;
  insuredPersons?: InputMaybe<Array<InsuredPersonsCalclulationInput>>;
  travelData: SoTravelTravelData;
};

export type CalculationProductDto = {
  __typename?: 'CalculationProductDto';
  _id: Scalars['String'];
  brandId: CalculationBrandDto;
  name: Scalars['String'];
  productTypeSpecific: CalculationProductTypeSpecificDto;
};

export type CalculationProductTypeSpecificDto = {
  __typename?: 'CalculationProductTypeSpecificDto';
  onlyPackage: Scalars['Boolean'];
  packageName?: Maybe<Scalars['String']>;
};

export type CallMeInput = {
  number: Scalars['String'];
  product: Scalars['String'];
  soId?: InputMaybe<Scalars['String']>;
};

export type CodebookDto = {
  __typename?: 'CodebookDto';
  label: Scalars['String'];
  value: Scalars['String'];
};

export type ContractorInput = {
  birthDate: Scalars['String'];
  city: Scalars['String'];
  cityKompareId: Scalars['String'];
  contractorIsPassenger: Scalars['Boolean'];
  email: Scalars['String'];
  firstName: Scalars['String'];
  houseNumber: Scalars['String'];
  lastName: Scalars['String'];
  oib: Scalars['String'];
  street: Scalars['String'];
  streetKompareId: Scalars['String'];
  zipCode: Scalars['Float'];
};

export type Coverage = {
  __typename?: 'Coverage';
  code: Scalars['String'];
  description: Scalars['String'];
  isPopular?: Maybe<Scalars['Boolean']>;
  label: Scalars['String'];
  variantType: Scalars['String'];
  variants: Array<CoverageVariant>;
};

export type CoverageVariant = {
  __typename?: 'CoverageVariant';
  code: Scalars['String'];
  label: Scalars['String'];
};

export type CreateSoInput = {
  email: Scalars['String'];
  soId?: InputMaybe<Scalars['String']>;
  source?: InputMaybe<Scalars['String']>;
  travelData: SoTravelTravelData;
  visitorIds?: InputMaybe<Array<Scalars['String']>>;
};

export type DisabledCoverageDto = {
  __typename?: 'DisabledCoverageDto';
  code: Scalars['String'];
  message: Scalars['String'];
};

export type FunnelStepType = {
  __typename?: 'FunnelStepType';
  code: Scalars['String'];
  openedAt: Scalars['String'];
};

export type FunnelType = {
  __typename?: 'FunnelType';
  latestStep: Scalars['String'];
  steps: Array<FunnelStepType>;
};

export type GetOfferDto = {
  __typename?: 'GetOfferDto';
  _id: Scalars['String'];
  departmentCode: Scalars['String'];
  offerNumber: Scalars['String'];
  product: OfferProductDto;
  productId: Scalars['String'];
  productType: OfferProductTypeDto;
  productTypeId: Scalars['String'];
  productTypeSpecific: OfferProductTypeSpecificDto;
  soId: Scalars['String'];
  status: Scalars['String'];
};

export type GetSoDto = {
  __typename?: 'GetSoDto';
  _id: Scalars['String'];
  email: Scalars['String'];
  fullName?: Maybe<Scalars['String']>;
  funnel: FunnelType;
  phoneNumber?: Maybe<Scalars['String']>;
  productTypeId: ProductTypeGraphQl;
  productTypeSpecific?: Maybe<ProductTypeSpecificType>;
  soNumber: Scalars['Float'];
  source: Scalars['String'];
  status: Scalars['String'];
};

export type IncludedCoverageDto = {
  __typename?: 'IncludedCoverageDto';
  brandCoverageCode: Scalars['String'];
  brandCoverageVariant?: Maybe<Scalars['String']>;
  code: Scalars['String'];
  description: Scalars['String'];
  disabled?: Maybe<Scalars['Boolean']>;
  label: Scalars['String'];
  variant: Scalars['String'];
  variantInfo: Scalars['String'];
};

export type IncludedCoverageInput = {
  code: Scalars['String'];
  variant: Scalars['String'];
};

export type IncludedCoverageOfferDto = {
  __typename?: 'IncludedCoverageOfferDto';
  code: Scalars['String'];
  codeDescription: Scalars['String'];
  disabled?: Maybe<Scalars['Boolean']>;
  variant: Scalars['String'];
  variantDescription: Scalars['String'];
};

export type InsuredPersonsCalclulationInput = {
  birthDate: Scalars['String'];
  child: Scalars['Boolean'];
  firstName: Scalars['String'];
  gender: Scalars['String'];
  lastName: Scalars['String'];
  oib?: InputMaybe<Scalars['String']>;
};

export type InsuredPersonsInput = {
  birthDate: Scalars['String'];
  child: Scalars['Boolean'];
  firstName: Scalars['String'];
  gender?: InputMaybe<Scalars['String']>;
  lastName: Scalars['String'];
  oib?: InputMaybe<Scalars['String']>;
};

/** Duration of the longest trip */
export enum LongestTripDuration {
  LessThanThreeMonths = 'LESS_THAN_THREE_MONTHS',
  MoreThanThreeMonths = 'MORE_THAN_THREE_MONTHS'
}

export type Mutation = {
  __typename?: 'Mutation';
  acceptTerms?: Maybe<Scalars['String']>;
  callMe: Scalars['String'];
  changeTravelInsuranceRange: Scalars['String'];
  createSo: Scalars['String'];
  finishOfflineOffer: Scalars['String'];
  generatePolicy: Scalars['String'];
  getWSPayPaymentDetails: WsPayPaymentDetailsDto;
  selectOffer: Scalars['String'];
  sendTermsAndConditionsToEmail?: Maybe<Scalars['String']>;
  setAsPaid: Scalars['String'];
  setContractorAndInsuredPersons: Scalars['String'];
  setPaymentErrors: Scalars['String'];
};


export type MutationAcceptTermsArgs = {
  id: Scalars['String'];
};


export type MutationCallMeArgs = {
  input: CallMeInput;
};


export type MutationChangeTravelInsuranceRangeArgs = {
  id: Scalars['String'];
  travelInsuranceRange: TravelInsuranceRange;
};


export type MutationCreateSoArgs = {
  input: CreateSoInput;
};


export type MutationFinishOfflineOfferArgs = {
  id: Scalars['String'];
};


export type MutationGeneratePolicyArgs = {
  id: Scalars['String'];
};


export type MutationGetWsPayPaymentDetailsArgs = {
  id: Scalars['String'];
  paymentType: Scalars['String'];
};


export type MutationSelectOfferArgs = {
  input: SelectOfferInput;
};


export type MutationSendTermsAndConditionsToEmailArgs = {
  id: Scalars['String'];
};


export type MutationSetAsPaidArgs = {
  id: Scalars['String'];
  input: WsPayResponseInput;
};


export type MutationSetContractorAndInsuredPersonsArgs = {
  id: Scalars['String'];
  input: SetContractorAndInsuredPersonsInput;
  offerId: Scalars['String'];
};


export type MutationSetPaymentErrorsArgs = {
  id: Scalars['String'];
  input: SetPaymentErrorsInput;
};

export type OfferBrandDto = {
  __typename?: 'OfferBrandDto';
  _id: Scalars['String'];
  code: Scalars['String'];
  name: Scalars['String'];
  shortName: Scalars['String'];
};

export type OfferPriceDto = {
  __typename?: 'OfferPriceDto';
  discount: Scalars['Float'];
  price: Scalars['Float'];
  totalPrice: Scalars['Float'];
};

export type OfferProductDto = {
  __typename?: 'OfferProductDto';
  brand: OfferBrandDto;
  brandId: Scalars['String'];
  name: Scalars['String'];
  productTypeSpecific: OfferProductProductTypeSpecificDto;
};

export type OfferProductProductTypeSpecificDto = {
  __typename?: 'OfferProductProductTypeSpecificDto';
  offline?: Maybe<Scalars['Boolean']>;
  onlyPackage: Scalars['Boolean'];
  packageName?: Maybe<Scalars['String']>;
};

export type OfferProductTypeDto = {
  __typename?: 'OfferProductTypeDto';
  code: Scalars['String'];
  departmentCode: Scalars['String'];
  name: Scalars['String'];
};

export type OfferProductTypeSpecificDto = {
  __typename?: 'OfferProductTypeSpecificDto';
  calculationJson: Scalars['String'];
  includedCoverages: Array<IncludedCoverageOfferDto>;
  paidAt?: Maybe<Scalars['String']>;
  price: OfferPriceDto;
  termsAcceptedAt?: Maybe<Scalars['String']>;
};

export type OfferTermsAndConditionsDocumentDto = {
  __typename?: 'OfferTermsAndConditionsDocumentDto';
  fileId: Scalars['String'];
  fileName: Scalars['String'];
};

export type OfferTermsAndConditionsGetDto = {
  __typename?: 'OfferTermsAndConditionsGetDto';
  brandCode: Scalars['String'];
  brandName: Scalars['String'];
  documents: Array<OfferTermsAndConditionsDocumentDto>;
};

export type PickedCalculationBrandInput = {
  _id: Scalars['String'];
  code: Scalars['String'];
  name: Scalars['String'];
  shortName: Scalars['String'];
};

export type PickedCalculationDto = {
  brandCode: Scalars['String'];
  includedCoverages: Array<PickedCalculationIncludedCoverageInput>;
  price: Scalars['Float'];
  product: PickedCalculationProductInput;
};

export type PickedCalculationIncludedCoverageInput = {
  code: Scalars['String'];
  description: Scalars['String'];
  disabled?: InputMaybe<Scalars['Boolean']>;
  label: Scalars['String'];
  variant: Scalars['String'];
  variantInfo: Scalars['String'];
};

export type PickedCalculationProductInput = {
  _id: Scalars['String'];
  brandId: PickedCalculationBrandInput;
  name: Scalars['String'];
  productTypeSpecific: PickedCalculationProductTypeSpecificInput;
};

export type PickedCalculationProductTypeSpecificInput = {
  onlyPackage: Scalars['Boolean'];
  packageName?: InputMaybe<Scalars['String']>;
};

export type PokricaVariantDto = {
  __typename?: 'PokricaVariantDto';
  opis: Scalars['String'];
  sifra: Scalars['String'];
};

export type PriceDto = {
  __typename?: 'PriceDto';
  disabledCoverageCodes?: Maybe<Array<DisabledCoverageDto>>;
  discount: Scalars['Float'];
  price: Scalars['Float'];
  quoteNumber?: Maybe<Scalars['String']>;
  totalPrice: Scalars['Float'];
};

export type ProductTypeGraphQl = {
  __typename?: 'ProductTypeGraphQL';
  _id: Scalars['ID'];
  code: Scalars['String'];
  name: Scalars['String'];
};

export type ProductTypeSpecificType = {
  __typename?: 'ProductTypeSpecificType';
  contractor?: Maybe<SoTravelContractorData>;
  insuredPersons?: Maybe<Array<SoTravelInsuredPersonsData>>;
  travelData?: Maybe<TravelDataType>;
};

export type Query = {
  __typename?: 'Query';
  getCalculations: CalculationDto;
  getOffer?: Maybe<GetOfferDto>;
  getSo?: Maybe<GetSoDto>;
  getSportActivities: Array<CodebookDto>;
  getTermsAndConditions?: Maybe<OfferTermsAndConditionsGetDto>;
  getTermsAndConditionsById?: Maybe<TermsAndConditionsDto>;
  getTermsAndConditionsFromFiles?: Maybe<OfferTermsAndConditionsGetDto>;
};


export type QueryGetCalculationsArgs = {
  input: CalculationInput;
};


export type QueryGetOfferArgs = {
  id: Scalars['String'];
};


export type QueryGetSoArgs = {
  id: Scalars['String'];
};


export type QueryGetTermsAndConditionsArgs = {
  id: Scalars['String'];
};


export type QueryGetTermsAndConditionsByIdArgs = {
  id: Scalars['String'];
};


export type QueryGetTermsAndConditionsFromFilesArgs = {
  id: Scalars['String'];
};

export type SelectOfferInput = {
  pickedCalculation: PickedCalculationDto;
  soId: Scalars['String'];
};

export type SetContractorAndInsuredPersonsInput = {
  contractor: ContractorInput;
  insuredPersons: Array<InsuredPersonsInput>;
};

export type SetPaymentErrorsInput = {
  paymentErrors: Array<Scalars['String']>;
};

export type SoTravelContractorData = {
  __typename?: 'SoTravelContractorData';
  birthDate?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  cityKompareId?: Maybe<Scalars['String']>;
  contractorIsPassenger?: Maybe<Scalars['Boolean']>;
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  houseNumber?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  oib?: Maybe<Scalars['String']>;
  street?: Maybe<Scalars['String']>;
  streetKompareId?: Maybe<Scalars['String']>;
  zipCode?: Maybe<Scalars['Float']>;
};

export type SoTravelInsuredPersonsData = {
  __typename?: 'SoTravelInsuredPersonsData';
  birthDate?: Maybe<Scalars['String']>;
  child?: Maybe<Scalars['Boolean']>;
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  oib?: Maybe<Scalars['String']>;
};

export type SoTravelTravelData = {
  allInsuredPersonsAreFromTheSameFamily: Scalars['Boolean'];
  insuranceEndDate?: InputMaybe<Scalars['String']>;
  insuranceRange: TravelInsuranceRange;
  insuranceStartDate: Scalars['String'];
  insuranceType: TravelInsuranceType;
  longestTripDuration?: InputMaybe<LongestTripDuration>;
  longestTripDurationDays?: InputMaybe<Scalars['Float']>;
  luggageValue?: InputMaybe<Scalars['Float']>;
  numOfInsuredAdults: Scalars['Float'];
  numOfInsuredChildren: Scalars['Float'];
  numOfInsuredPersons: Scalars['Float'];
  sportActivities: TravelSportActivities;
  sportActivityCode?: InputMaybe<Scalars['String']>;
  travelDestination: TravelDestination;
  tripValue?: InputMaybe<Scalars['Float']>;
  willWorkOnTrip: Scalars['Boolean'];
};

export type TermsAndConditionsDto = {
  __typename?: 'TermsAndConditionsDto';
  contentType: Scalars['String'];
  downloadUrl: Scalars['String'];
  fileName: Scalars['String'];
};

export type TravelDataType = {
  __typename?: 'TravelDataType';
  allInsuredPersonsAreFromTheSameFamily: Scalars['Boolean'];
  insuranceEndDate?: Maybe<Scalars['String']>;
  insuranceRange: TravelInsuranceRange;
  insuranceStartDate: Scalars['String'];
  insuranceType: TravelInsuranceType;
  longestTripDuration?: Maybe<LongestTripDuration>;
  longestTripDurationDays?: Maybe<Scalars['Float']>;
  luggageValue?: Maybe<Scalars['Float']>;
  numOfInsuredAdults: Scalars['Float'];
  numOfInsuredChildren: Scalars['Float'];
  numOfInsuredPersons: Scalars['Float'];
  sportActivities: TravelSportActivities;
  sportActivityCode?: Maybe<Scalars['String']>;
  travelDestination: TravelDestination;
  tripValue?: Maybe<Scalars['Float']>;
  willWorkOnTrip: Scalars['Boolean'];
};

/** Destination of travel */
export enum TravelDestination {
  Europe = 'EUROPE',
  World = 'WORLD'
}

/** Insurance coverage range */
export enum TravelInsuranceRange {
  ForthyToSixty = 'FORTHY_TO_SIXTY',
  MoreThanSixty = 'MORE_THAN_SIXTY',
  TenTwenty = 'TEN_TWENTY',
  TwentyForthy = 'TWENTY_FORTHY'
}

/** Type of travel insurance */
export enum TravelInsuranceType {
  Single = 'SINGLE',
  Year = 'YEAR'
}

/** Type of sport activities during travel */
export enum TravelSportActivities {
  Amateur = 'AMATEUR',
  None = 'NONE',
  Professional = 'PROFESSIONAL'
}

export type WsPayPaymentDetailsDto = {
  __typename?: 'WSPayPaymentDetailsDto';
  CustomerAddress: Scalars['String'];
  CustomerCity: Scalars['String'];
  CustomerCountry: Scalars['String'];
  CustomerEmail: Scalars['String'];
  CustomerFirstName: Scalars['String'];
  CustomerLastName: Scalars['String'];
  CustomerPhone: Scalars['String'];
  CustomerZIP: Scalars['String'];
  Iframe: Scalars['String'];
  IframeResponseTarget: Scalars['String'];
  PaymentMethod: Scalars['String'];
  PaymentPlan?: Maybe<Scalars['String']>;
  ShopID: Scalars['String'];
  ShoppingCartID: Scalars['String'];
  Signature: Scalars['String'];
  TotalAmount: Scalars['String'];
  Version: Scalars['String'];
};

export type WsPayResponseInput = {
  wsPayAmount: Scalars['String'];
  wsPayApprovalCode: Scalars['String'];
  wsPayCallback?: Scalars['Boolean'];
  wsPayConfirmationSignature: Scalars['String'];
  wsPayCreditCardNumber: Scalars['String'];
  wsPayCustomerFirstName: Scalars['String'];
  wsPayCustomerLastName: Scalars['String'];
  wsPayDateTime: Scalars['String'];
  wsPayOrderId: Scalars['String'];
  wsPayPartner: Scalars['String'];
  wsPayPaymentPlan: Scalars['String'];
  wsPayPaymentType: Scalars['String'];
  wsPaySTAN: Scalars['String'];
  wsPayShoppingCartId: Scalars['String'];
  wsPaySuccess: Scalars['String'];
};

export type GetCalculationsQueryVariables = Exact<{
  input: CalculationInput;
}>;


export type GetCalculationsQuery = { __typename?: 'Query', getCalculations: { __typename?: 'CalculationDto', calculations: Array<{ __typename?: 'BrandCalculationDto', brandCode: string, product: { __typename?: 'CalculationProductDto', _id: string, name: string, brandId: { __typename?: 'CalculationBrandDto', _id: string, code: string, name: string, shortName: string }, productTypeSpecific: { __typename?: 'CalculationProductTypeSpecificDto', onlyPackage: boolean, packageName?: string | null } }, includedCoverages: Array<{ __typename?: 'IncludedCoverageDto', code: string, variant: string, label: string, description: string, variantInfo: string, disabled?: boolean | null }>, price: { __typename?: 'PriceDto', price: number, discount: number, totalPrice: number } }>, additionalCoverages: Array<{ __typename?: 'Coverage', code: string, description: string, label: string, isPopular?: boolean | null, variantType: string, variants: Array<{ __typename?: 'CoverageVariant', code: string, label: string }> }> } };

export type GetTermsAndConditionsByIdQueryVariables = Exact<{
  fileId: Scalars['String'];
}>;


export type GetTermsAndConditionsByIdQuery = { __typename?: 'Query', getTermsAndConditionsById?: { __typename?: 'TermsAndConditionsDto', fileName: string, contentType: string, downloadUrl: string } | null };

export type GetOfferQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetOfferQuery = { __typename?: 'Query', getOffer?: { __typename?: 'GetOfferDto', _id: string, offerNumber: string, soId: string, status: string, productTypeId: string, departmentCode: string, productId: string, productType: { __typename?: 'OfferProductTypeDto', code: string, name: string, departmentCode: string }, productTypeSpecific: { __typename?: 'OfferProductTypeSpecificDto', calculationJson: string, paidAt?: string | null, termsAcceptedAt?: string | null, includedCoverages: Array<{ __typename?: 'IncludedCoverageOfferDto', code: string, variant: string, codeDescription: string, variantDescription: string, disabled?: boolean | null }>, price: { __typename?: 'OfferPriceDto', price: number, discount: number, totalPrice: number } }, product: { __typename?: 'OfferProductDto', name: string, brandId: string, brand: { __typename?: 'OfferBrandDto', _id: string, code: string, name: string, shortName: string }, productTypeSpecific: { __typename?: 'OfferProductProductTypeSpecificDto', onlyPackage: boolean, packageName?: string | null, offline?: boolean | null } } } | null };

export type GetSoQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetSoQuery = { __typename?: 'Query', getSo?: { __typename?: 'GetSoDto', _id: string, soNumber: number, status: string, source: string, email: string, phoneNumber?: string | null, fullName?: string | null, productTypeId: { __typename?: 'ProductTypeGraphQL', code: string, name: string }, funnel: { __typename?: 'FunnelType', latestStep: string, steps: Array<{ __typename?: 'FunnelStepType', code: string, openedAt: string }> }, productTypeSpecific?: { __typename?: 'ProductTypeSpecificType', travelData?: { __typename?: 'TravelDataType', insuranceType: TravelInsuranceType, insuranceStartDate: string, insuranceEndDate?: string | null, travelDestination: TravelDestination, insuranceRange: TravelInsuranceRange, sportActivities: TravelSportActivities, willWorkOnTrip: boolean, numOfInsuredPersons: number, numOfInsuredChildren: number, numOfInsuredAdults: number, allInsuredPersonsAreFromTheSameFamily: boolean, tripValue?: number | null, luggageValue?: number | null, longestTripDuration?: LongestTripDuration | null, longestTripDurationDays?: number | null, sportActivityCode?: string | null } | null, contractor?: { __typename?: 'SoTravelContractorData', firstName?: string | null, lastName?: string | null, birthDate?: string | null, oib?: string | null, city?: string | null, cityKompareId?: string | null, street?: string | null, streetKompareId?: string | null, zipCode?: number | null, houseNumber?: string | null, email?: string | null, contractorIsPassenger?: boolean | null } | null, insuredPersons?: Array<{ __typename?: 'SoTravelInsuredPersonsData', firstName?: string | null, lastName?: string | null, birthDate?: string | null, oib?: string | null }> | null } | null } | null };

export type GetSportActivitiesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSportActivitiesQuery = { __typename?: 'Query', getSportActivities: Array<{ __typename?: 'CodebookDto', value: string, label: string }> };

export type GetTermsAndConditionsQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetTermsAndConditionsQuery = { __typename?: 'Query', getTermsAndConditions?: { __typename?: 'OfferTermsAndConditionsGetDto', brandName: string, brandCode: string, documents: Array<{ __typename?: 'OfferTermsAndConditionsDocumentDto', fileId: string, fileName: string }> } | null };

export type GetTermsAndConditionsFromFilesQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetTermsAndConditionsFromFilesQuery = { __typename?: 'Query', getTermsAndConditionsFromFiles?: { __typename?: 'OfferTermsAndConditionsGetDto', brandName: string, brandCode: string, documents: Array<{ __typename?: 'OfferTermsAndConditionsDocumentDto', fileId: string, fileName: string }> } | null };


export const GetCalculationsDocument = gql`
    query GetCalculations($input: CalculationInput!) {
  getCalculations(input: $input) {
    calculations {
      brandCode
      product {
        _id
        name
        brandId {
          _id
          code
          name
          shortName
        }
        productTypeSpecific {
          onlyPackage
          packageName
        }
      }
      includedCoverages {
        code
        variant
        label
        description
        variantInfo
        disabled
      }
      price {
        price
        discount
        totalPrice
      }
    }
    additionalCoverages {
      code
      description
      label
      isPopular
      variantType
      variants {
        code
        label
      }
    }
  }
}
    `;

/**
 * __useGetCalculationsQuery__
 *
 * To run a query within a React component, call `useGetCalculationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCalculationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCalculationsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetCalculationsQuery(baseOptions: Apollo.QueryHookOptions<GetCalculationsQuery, GetCalculationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCalculationsQuery, GetCalculationsQueryVariables>(GetCalculationsDocument, options);
      }
export function useGetCalculationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCalculationsQuery, GetCalculationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCalculationsQuery, GetCalculationsQueryVariables>(GetCalculationsDocument, options);
        }
export type GetCalculationsQueryHookResult = ReturnType<typeof useGetCalculationsQuery>;
export type GetCalculationsLazyQueryHookResult = ReturnType<typeof useGetCalculationsLazyQuery>;
export type GetCalculationsQueryResult = Apollo.QueryResult<GetCalculationsQuery, GetCalculationsQueryVariables>;
export const GetTermsAndConditionsByIdDocument = gql`
    query GetTermsAndConditionsById($fileId: String!) {
  getTermsAndConditionsById(id: $fileId) {
    fileName
    contentType
    downloadUrl
  }
}
    `;

/**
 * __useGetTermsAndConditionsByIdQuery__
 *
 * To run a query within a React component, call `useGetTermsAndConditionsByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTermsAndConditionsByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTermsAndConditionsByIdQuery({
 *   variables: {
 *      fileId: // value for 'fileId'
 *   },
 * });
 */
export function useGetTermsAndConditionsByIdQuery(baseOptions: Apollo.QueryHookOptions<GetTermsAndConditionsByIdQuery, GetTermsAndConditionsByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTermsAndConditionsByIdQuery, GetTermsAndConditionsByIdQueryVariables>(GetTermsAndConditionsByIdDocument, options);
      }
export function useGetTermsAndConditionsByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTermsAndConditionsByIdQuery, GetTermsAndConditionsByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTermsAndConditionsByIdQuery, GetTermsAndConditionsByIdQueryVariables>(GetTermsAndConditionsByIdDocument, options);
        }
export type GetTermsAndConditionsByIdQueryHookResult = ReturnType<typeof useGetTermsAndConditionsByIdQuery>;
export type GetTermsAndConditionsByIdLazyQueryHookResult = ReturnType<typeof useGetTermsAndConditionsByIdLazyQuery>;
export type GetTermsAndConditionsByIdQueryResult = Apollo.QueryResult<GetTermsAndConditionsByIdQuery, GetTermsAndConditionsByIdQueryVariables>;
export const GetOfferDocument = gql`
    query GetOffer($id: String!) {
  getOffer(id: $id) {
    _id
    offerNumber
    soId
    status
    productTypeId
    departmentCode
    productType {
      code
      name
      departmentCode
    }
    productTypeSpecific {
      calculationJson
      includedCoverages {
        code
        variant
        codeDescription
        variantDescription
        disabled
      }
      price {
        price
        discount
        totalPrice
      }
      paidAt
      termsAcceptedAt
    }
    productId
    product {
      name
      brand {
        _id
        code
        name
        shortName
      }
      brandId
      productTypeSpecific {
        onlyPackage
        packageName
        offline
      }
    }
  }
}
    `;

/**
 * __useGetOfferQuery__
 *
 * To run a query within a React component, call `useGetOfferQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOfferQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOfferQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetOfferQuery(baseOptions: Apollo.QueryHookOptions<GetOfferQuery, GetOfferQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOfferQuery, GetOfferQueryVariables>(GetOfferDocument, options);
      }
export function useGetOfferLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOfferQuery, GetOfferQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOfferQuery, GetOfferQueryVariables>(GetOfferDocument, options);
        }
export type GetOfferQueryHookResult = ReturnType<typeof useGetOfferQuery>;
export type GetOfferLazyQueryHookResult = ReturnType<typeof useGetOfferLazyQuery>;
export type GetOfferQueryResult = Apollo.QueryResult<GetOfferQuery, GetOfferQueryVariables>;
export const GetSoDocument = gql`
    query GetSo($id: String!) {
  getSo(id: $id) {
    _id
    soNumber
    status
    source
    email
    phoneNumber
    fullName
    productTypeId {
      code
      name
    }
    funnel {
      steps {
        code
        openedAt
      }
      latestStep
    }
    productTypeSpecific {
      travelData {
        insuranceType
        insuranceStartDate
        insuranceEndDate
        travelDestination
        insuranceRange
        sportActivities
        willWorkOnTrip
        numOfInsuredPersons
        numOfInsuredChildren
        numOfInsuredAdults
        allInsuredPersonsAreFromTheSameFamily
        tripValue
        luggageValue
        longestTripDuration
        longestTripDurationDays
        sportActivityCode
      }
      contractor {
        firstName
        lastName
        birthDate
        oib
        city
        cityKompareId
        street
        streetKompareId
        zipCode
        houseNumber
        email
        contractorIsPassenger
      }
      insuredPersons {
        firstName
        lastName
        birthDate
        oib
      }
    }
  }
}
    `;

/**
 * __useGetSoQuery__
 *
 * To run a query within a React component, call `useGetSoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSoQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetSoQuery(baseOptions: Apollo.QueryHookOptions<GetSoQuery, GetSoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSoQuery, GetSoQueryVariables>(GetSoDocument, options);
      }
export function useGetSoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSoQuery, GetSoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSoQuery, GetSoQueryVariables>(GetSoDocument, options);
        }
export type GetSoQueryHookResult = ReturnType<typeof useGetSoQuery>;
export type GetSoLazyQueryHookResult = ReturnType<typeof useGetSoLazyQuery>;
export type GetSoQueryResult = Apollo.QueryResult<GetSoQuery, GetSoQueryVariables>;
export const GetSportActivitiesDocument = gql`
    query GetSportActivities {
  getSportActivities {
    value
    label
  }
}
    `;

/**
 * __useGetSportActivitiesQuery__
 *
 * To run a query within a React component, call `useGetSportActivitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSportActivitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSportActivitiesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSportActivitiesQuery(baseOptions?: Apollo.QueryHookOptions<GetSportActivitiesQuery, GetSportActivitiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSportActivitiesQuery, GetSportActivitiesQueryVariables>(GetSportActivitiesDocument, options);
      }
export function useGetSportActivitiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSportActivitiesQuery, GetSportActivitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSportActivitiesQuery, GetSportActivitiesQueryVariables>(GetSportActivitiesDocument, options);
        }
export type GetSportActivitiesQueryHookResult = ReturnType<typeof useGetSportActivitiesQuery>;
export type GetSportActivitiesLazyQueryHookResult = ReturnType<typeof useGetSportActivitiesLazyQuery>;
export type GetSportActivitiesQueryResult = Apollo.QueryResult<GetSportActivitiesQuery, GetSportActivitiesQueryVariables>;
export const GetTermsAndConditionsDocument = gql`
    query GetTermsAndConditions($id: String!) {
  getTermsAndConditions(id: $id) {
    brandName
    brandCode
    documents {
      fileId
      fileName
    }
  }
}
    `;

/**
 * __useGetTermsAndConditionsQuery__
 *
 * To run a query within a React component, call `useGetTermsAndConditionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTermsAndConditionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTermsAndConditionsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetTermsAndConditionsQuery(baseOptions: Apollo.QueryHookOptions<GetTermsAndConditionsQuery, GetTermsAndConditionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTermsAndConditionsQuery, GetTermsAndConditionsQueryVariables>(GetTermsAndConditionsDocument, options);
      }
export function useGetTermsAndConditionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTermsAndConditionsQuery, GetTermsAndConditionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTermsAndConditionsQuery, GetTermsAndConditionsQueryVariables>(GetTermsAndConditionsDocument, options);
        }
export type GetTermsAndConditionsQueryHookResult = ReturnType<typeof useGetTermsAndConditionsQuery>;
export type GetTermsAndConditionsLazyQueryHookResult = ReturnType<typeof useGetTermsAndConditionsLazyQuery>;
export type GetTermsAndConditionsQueryResult = Apollo.QueryResult<GetTermsAndConditionsQuery, GetTermsAndConditionsQueryVariables>;
export const GetTermsAndConditionsFromFilesDocument = gql`
    query getTermsAndConditionsFromFiles($id: String!) {
  getTermsAndConditionsFromFiles(id: $id) {
    brandName
    brandCode
    documents {
      fileId
      fileName
    }
  }
}
    `;

/**
 * __useGetTermsAndConditionsFromFilesQuery__
 *
 * To run a query within a React component, call `useGetTermsAndConditionsFromFilesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTermsAndConditionsFromFilesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTermsAndConditionsFromFilesQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetTermsAndConditionsFromFilesQuery(baseOptions: Apollo.QueryHookOptions<GetTermsAndConditionsFromFilesQuery, GetTermsAndConditionsFromFilesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTermsAndConditionsFromFilesQuery, GetTermsAndConditionsFromFilesQueryVariables>(GetTermsAndConditionsFromFilesDocument, options);
      }
export function useGetTermsAndConditionsFromFilesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTermsAndConditionsFromFilesQuery, GetTermsAndConditionsFromFilesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTermsAndConditionsFromFilesQuery, GetTermsAndConditionsFromFilesQueryVariables>(GetTermsAndConditionsFromFilesDocument, options);
        }
export type GetTermsAndConditionsFromFilesQueryHookResult = ReturnType<typeof useGetTermsAndConditionsFromFilesQuery>;
export type GetTermsAndConditionsFromFilesLazyQueryHookResult = ReturnType<typeof useGetTermsAndConditionsFromFilesLazyQuery>;
export type GetTermsAndConditionsFromFilesQueryResult = Apollo.QueryResult<GetTermsAndConditionsFromFilesQuery, GetTermsAndConditionsFromFilesQueryVariables>;